(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ma-wardrobe-edit"] && !Shopify.designMode) return;
  try {
    
  function initMaisonWardrobe(root = document) {
    const sections = Array.from(root.querySelectorAll('.ma-wardrobe:not(.is-visible)'));
    if (root.matches && root.matches('.ma-wardrobe:not(.is-visible)')) sections.push(root);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('is-pending');
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    sections.forEach((section) => {
      section.classList.add('is-pending');
      observer.observe(section);
    });
  }
  initMaisonWardrobe();
  document.addEventListener('shopify:section:load', (event) => initMaisonWardrobe(event.target));
  function initMaisonWardrobeControls(root = document) {
    const sections = Array.from(root.querySelectorAll('.ma-wardrobe'));
    if (root.matches && root.matches('.ma-wardrobe')) sections.push(root);
    sections.forEach((section) => {
      if (section.dataset.wardrobeControlsReady) return;
      const rail = section.querySelector('.ma-wardrobe__rail');
      if (!rail) return;
      section.querySelectorAll('[data-wardrobe-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = rail.querySelector('.ma-wardrobe__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
          const distance = (card.getBoundingClientRect().width + gap) * Number(button.dataset.wardrobeStep);
          const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
          rail.scrollBy({ left: distance, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
      });
      section.dataset.wardrobeControlsReady = 'true';
    });
  }
  initMaisonWardrobeControls();
  document.addEventListener('shopify:section:load', (event) => initMaisonWardrobeControls(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
